import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        headerBar: {
            width: '100%',
            overflowX: 'clip',
            backgroundColor: 'background.base.default',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        container: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'stretch',
            height: remCalc(56),
        },
        content: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignSelf: 'stretch',
            height: '100%',
            width: '100%',
            position: 'relative',
        },
        desktopContent: {
            '@media (min-width: 1200px)': {
                justifyContent: 'center',
            },
        },
        desktopLogo: {
            '@media (min-width: 1200px)': {
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                transform: 'none',
            },
        },
        desktopActions: {
            '@media (min-width: 1200px)': {
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
            },
        },
        bodyContainer: {
            display: 'flex',
            alignItems: 'center',
            '@media (max-width: 1199px)': {
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
            },
            '@media (min-width: 1200px)': {
                position: 'static',
                left: 'auto',
                transform: 'none',
            },
        },
        bodyContainerGap: {
            '@media (max-width: 1199px)': {
                gap: 0,
            },
            '@media (min-width: 1200px)': {
                gap: remCalc(30),
            },
        },
        linksAndIcons: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 'xsmall-1.base',
        },
        iconsFlex: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        iconsFlexGap: {
            gap: {
                base: 'xsmall.base',
                sm: 'xsmall.base',
                md: 'xsmall-1.base',
                lg: 'xsmall-1.base',
            },
        },
        headerIcon: {
            width: 'iconsSize.small',
            height: 'iconsSize.small',
            color: 'foreground.neutral.default',
        },
        headerButton: {
            backgroundColor: 'background.accent.muted',
            borderRadius: 'full',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: remCalc(32),
            height: remCalc(32),
            minWidth: remCalc(32),
            minHeight: remCalc(32),
            maxWidth: remCalc(32),
            maxHeight: remCalc(32),
            p: 0,
        },
        links: {
            textStyle: 'body-small',
            color: 'text.grey',
            verticalAlign: 'middle',
            fontWeight: 'medium',
            opacity: 0.8,
        },
        logo: {
            width: remCalc(77),
            height: {
                base: remCalc(24),
                sm: remCalc(24),
                md: remCalc(24),
                lg: remCalc(32),
            },
        },
        wishlistIcon: {
            width: 'iconsSize.small',
            height: 'iconsSize.small',
            color: 'foreground.neutral.default',
        },
        wishlistBadge: {
            top: 'auto',
            bottom: remCalc(18),
            right: remCalc(-10),
            backgroundColor: 'background.alternative',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            alignItems: 'center',
            width: remCalc(20),
            height: remCalc(20),
            p: 0,
        },
        accountIcon: {
            width: 'iconsSize.small',
            height: 'iconsSize.small',
            color: 'foreground.neutral.default',
        },
        cartIcon: {
            width: 'iconsSize.small',
            height: 'iconsSize.small',
            color: 'foreground.neutral.default',
        },
        initialsText: {
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            color: 'foreground.neutral.inverse',
            lineHeight: 1,
            '@media (max-width: 1199px)': {
                textStyle: 'body-xxsmall',
            },
            '@media (min-width: 1200px)': {
                textStyle: 'body-xxsmall',
            },
        },
        burgerIcon: {
            width: 'iconsSize.small',
            height: 'iconsSize.small',
            color: 'foreground.neutral.default',
        },
        buttonIcons: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: remCalc(32),
            height: remCalc(32),
        },
        arrowDownIcon: {
            width: [remCalc(15), remCalc(15), remCalc(15), remCalc(15)],
            height: [remCalc(16), remCalc(16), remCalc(16), remCalc(16)],
        },
        signout: {
            width: '100%',
            borderRadius: '4px',
            height: 11,
            padding: 4,
            py: 3,
            marginTop: 1,
            _hover: {
                background: 'gray.50',
            },
        },
        signoutText: {
            fontSize: 'sm',
            fontWeight: 'normal',
        },
        signoutIcon: {
            marginRight: 2,
        },
        hideOnMobile: {
            '@media (max-width: 1199px)': {
                display: 'none',
            },
            '@media (min-width: 1200px)': {
                display: 'flex',
            },
        },
        hideOnDesktop: {
            '@media (max-width: 1199px)': {
                display: 'flex',
                gap: 'xxsmall-1.base',
            },
            '@media (min-width: 1200px)': {
                display: 'none',
            },
        },
        showOnXl: {
            '@media (max-width: 1530px)': {
                display: 'none',
            },
            '@media (min-width: 1531px)': {
                display: 'flex',
            },
        },
        showOnLgOnly: {
            '@media (max-width: 1199px)': {
                display: 'none',
            },
            '@media (min-width: 1400px)': {
                display: 'none',
            },
        },
        supportIcon: {
            fill: 'background.default',
            color: 'background.dark',
            strokewidthnumber: remCalc(3),
            boxSize: 'iconsSize.medium',
        },
        srOnly: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            height: '1px',
            margin: '-1px',
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: '1px',
        },
    },
    variants: {
        checkout: {
            headerBar: {
                width: '100%',
                backgroundColor: 'background.base.default',
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingX: {
                    base: remCalc(16),
                    md: remCalc(24),
                    lg: remCalc(24),
                    xl: remCalc(0),
                },
            },
            headerBarSpacing: {
                '@media (min-width: 1400px)': {
                    paddingX: remCalc(0),
                },
            },
            containerSpacing: {
                '@media (max-width: 768px)': {
                    paddingX: {base: remCalc(0), md: remCalc(16)},
                    paddingY: 'small.base',
                    paddingBottom: remCalc(16),
                    paddingTop: remCalc(16),
                },
                '@media (min-width: 768px) and (max-width: 1199px)': {
                    paddingY: 'small.lg',
                },
                '@media (min-width: 1200px) and (max-width: 1439px)': {
                    paddingY: 'small.lg',
                },
                '@media (min-width: 1440px)': {
                    paddingY: remCalc(30),
                    paddingX: {base: remCalc(40), xl: remCalc(0)},
                },
            },
        },
        kenwood: {
            iconsFlex: {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: remCalc(24),
            },
        },
    },

    parts: [
        'container',
        'content',
        'searchContainer',
        'bodyContainer',
        'buttonIcons',
        'logo',
        'icons',
        'signout',
        'headerBar',
        'headerBarSpacing',
        'containerSpacing',
        'wishlistIcon',
        'wishlistBadge',
        'accountIcon',
        'initialsText',
        'iconsFlex',
    ],
}
